<template>
    <div class="right-contx bgcolor-f6f5fa pull-right">
        <div class="top-titx font-16">基本信息</div>
        <div class="set-20180409-ccj">
            <div class="item set-info">
                <!--头像-->
                <!--表格-->
                    <div id="js_userinfo_form" class="form-ele-box form-inline-box" style="display: flex;">

                        <div>
                            <!-- 姓名 -->
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">姓名</label>
                                <div class="form-inp-area">
                                    <el-input v-model="userName" placeholder="请输入姓名"></el-input>
                                </div>
                            </div>
                            <!-- 身份证 -->
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">身份证</label>
                                <div class="form-inp-area">
                                    <el-input v-model="idCard" placeholder="请输入您的身份证号码" :disabled=true></el-input>
                                </div>
                            </div>
                            <!-- 手机号 -->
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">手机号</label>
                                <div class="form-inp-area">
                                    <el-input v-model="telephone" placeholder="请输入手机号码"></el-input>
                                </div>
                            </div>
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">邮箱</label>
                                <div class="form-inp-area">
                                    <el-input v-model="email" placeholder="请输入邮箱地址"></el-input>
                                </div>
                            </div>
                            <!-- 民族 -->
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">民族</label>
                                <div class="form-inp-area">

                                    <el-select v-model="nation" placeholder="请选择">
                                        <el-option v-for="item in nationList" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>

                                </div>
                            </div>
                            <!-- 学历 -->
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">学历</label>
                                <div class="form-inp-area">
                                    <el-select v-model="education" placeholder="请选择">
                                        <el-option v-for="(item,index) in educationList" :key="index" :label="item"
                                            :value="item"> </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <!-- 毕业时间 -->
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">毕业时间</label>
                                <div class="form-inp-area">
                                    <el-date-picker v-model="graduationTime" align="right" type="date"
                                        placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                        :picker-options="pickerOptions">
                                    </el-date-picker>
                                </div>
                            </div>
                            <!-- 政治面貌 -->
                            <div class="form-item clearfix">
                                <label class="form-label">政治面貌</label>
                                <div class="form-inp-area">
                                    <el-select v-model="politic_countenance" placeholder="请选择">
                                        <el-option v-for="(item,index) in politic_countenanceList" :key="index"
                                            :label="item" :value="item"> </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">头像</label>
                                <div class="input-row-wrapper">
                                    <div class="input-row-right adjust-upward">
                                        <div class="profile-image-wrapper">
                                            <a class="profile-image-upload">
                                                <img style="height: 135px;width: 105px;" class="profile-image"
                                                    :src="headPath">
                                                <div style="text-align: center;margin-top: 10px;">
                                                    <div class="profile-image-upload-btn">
                                                        <el-upload :action="action" :show-file-list="false"
                                                            :on-success="successFile">
                                                            <span>编辑头像</span>
                                                        </el-upload>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-item clearfix" style="display: flex;">
                                <label class="form-label">身份证人物面</label>
                                <div class="input-row-right adjust-upward">
                                    <div class="profile-image-wrapper">
                                        <el-upload :action="actionCardImageUrl" :show-file-list="false" :drag="true"
                                            :on-success="successFileIdCardReverse">
                                            <div class="layui-upload-drag" id="uploadIdCardReverse-btn">
                                                <i class="layui-icon layui-icon-upload"></i>
                                                <p>点击上传，或将文件拖拽到此处</p>
                                                <div class="layui-show" id="uploadDemoView">
                                                    <hr>
                                                    <img v-if="idCardReverseFlag"
                                                        src="../../../../static/img/idCardReverse.jpg" alt="上传成功后渲染"
                                                        style="max-width: 196px">
                                                    <img v-if="!idCardReverseFlag" :src="idCardReverse"
                                                        style="max-width: 196px">
                                                </div>
                                            </div>
                                        </el-upload>
                                    </div>
                                    <div class="personal-info-setting-body-real-name-tip f-fc9" style="color: red">
                                        <i class="layui-icon layui-icon-tips"></i>图片大小不得超过1mb。
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>
                    <div class="form-item clearfix" style="text-align: center;">
                        <label class="form-label"></label>
                        <button class="form-btn form-btn-blue" @click="update()">保存
                        </button>
                    </div>
            </div>
        </div>
    </div>



</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                action: '',
                headPath: '',
                headPathByValue: '',//头像保存路径

                idCardReverse: '',
                actionCardImageUrl: '',
                idCardReverseFlag: false,
                idCardReverseByValue: '',

                userName: '',
                telephone: '',
                email: '',
                nation: '',
                idCard: '',
                education: '',
                graduationTime: '',
                politic_countenance: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                nationList: ['汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '朝鲜族', '满族'
                    , '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族', '佤族', '畲族', '高山族'
                    , '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族'
                    , '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族'
                    , '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
                educationList: ['博士', '研究生', '本科', '专科', '高中', '初中', '小学', '其他'],
                politic_countenanceList: ['中共党员', '中共预备党员', '共青团员', '民革党员', '民盟盟员', '民建会员', '民进会员',
                '农工党党员', '致公党党员', '九三学社社员', '台盟盟员', '无党派人士', '群众', '其他'],
            }
        },
        created() {

            console.log(this.$storage.get("declareUser"));
            this.action = this.serverUrl + '/deUp/uploadUserHeadImage';

            this.actionCardImageUrl = this.serverUrl + '/deUp/uploadUserIdCardImage';

            this.idCardReverse = this.serverUrl + this.prefiexUrl + this.$storage.get("declareUser").idCardReverse;

            //头像路径拼接
            this.headPath = this.serverUrl + this.prefiexUrl + this.$storage.get("declareUser").headPath;

            this.$parent.Cut(this.$parent.list[3], 3);
            //查询赋值

            if (this.$storage.get("declareUser") === undefined) {
                this.$confirm('请先登录！').then(_ => {
                    this.$router.push('/login');
                }).catch(_ => { });
            }

            this.selectUserDetail();

        },
        methods: {
            //头像上传
            successFile(response, file, fileList) {

                this.headPath = this.serverUrl + this.prefiexUrl + response.src;

                this.headPathByValue = response.src;

                this.$message({
                    showClose: true,
                    message: '恭喜你，文件上传成功！',
                    type: 'success'
                });
            },
            //正面
            successFileIdCardReverse(response, file, fileList) {
                this.idCardReverse = this.serverUrl + this.prefiexUrl + response.src;
                this.idCardReverseByValue = response.src;
                this.idCardReverseFlag = false;
                this.$message({
                    showClose: true,
                    message: '恭喜你，文件上传成功！',
                    type: 'success'
                });
            },
            selectUserDetail() {

                let parames = new URLSearchParams();
                parames.append('idCard', this.$storage.get("declareUser").idCard);

                this.$axios.post(this.serverUrl + '/getDeclareUserData', parames).then(resp => {

                    if (resp.data.code === 1) {
                        this.userName = resp.data.data.userName;
                        this.telephone = resp.data.data.telephone;
                        this.email = resp.data.data.email;
                        this.nation = resp.data.data.nation;
                        this.education = resp.data.data.education;
                        this.graduationTime = resp.data.data.graduationTime;
                        this.politic_countenance = resp.data.data.politic_countenance;
                        this.idCard = resp.data.data.idCard;
                    }
                }).catch(err => {
                    this.$message({
                        message: '服务器繁忙！',
                        type: 'warning'
                    });
                })

            },
            update() {
                const loading = this.$loading({
                    lock: true,
                    text: '修改中，请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                console.log(this.$storage.get("declareUser"));

                if ((this.$storage.get("declareUser").headPath == null || this.$storage.get("declareUser").headPath == '') && this.headPathByValue == '') {
                    this.$message({
                        message: '请上传头像！',
                        type: 'warning'
                    });
                    return false;
                } else if ((this.$storage.get("declareUser").idCardReverse == null || this.$storage.get("declareUser").idCardReverse == '') && this.idCardReverseByValue == '') {
                    this.$message({
                        message: '请上传身份证正面！',
                        type: 'warning'
                    });
                    return false;
                }
                let parames = new URLSearchParams();
                parames.append('id', this.$storage.get("declareUser").id);
                parames.append('idCard', this.$storage.get("declareUser").idCard);
                parames.append('userName', this.userName);
                parames.append('telephone', this.telephone);
                parames.append('email', this.email);
                parames.append('nation', this.nation);
                parames.append('education', this.education);
                parames.append('graduationTime', this.graduationTime + ' 00:00:00');
                parames.append('politic_countenance', this.politic_countenance);

                if (this.idCardReverseByValue != '') {
                    parames.append('idCardReverse', this.idCardReverseByValue);
                } else {
                    parames.append('idCardReverse', this.$storage.get("declareUser").idCardReverse);
                }

                if (this.headPathByValue != '') {
                    parames.append('headPath', this.headPathByValue);
                } else {
                    parames.append('headPath', this.$storage.get("declareUser").headPath);
                }


                this.$axios.post(this.serverUrl + '/updateUserInfo', parames).then(resp => {
                    loading.close();
                    if (resp.data.code === 1) {


                        if (resp.data.compareCode === 1) {


                            if (this.idCardReverseByValue != '') {

                                let userDate = this.$storage.get("declareUser");

                                userDate.idCardReverse = this.idCardReverseByValue;

                                this.$storage.set("declareUser", userDate);
                            }

                            if (this.headPathByValue != '') {

                                let userDate = this.$storage.get("declareUser");

                                userDate.headPath = this.headPathByValue;

                                this.$storage.set("declareUser", userDate);
                            }



                            this.$message({
                                message: '修改成功',
                                offset: 100,
                                type: 'success',
                                duration: 1500
                            });

                           /*  setTimeout(() => {
                                this.$router.go(0);
                            }, 1000); */


                        } else {
                            this.$message({
                                message: '头像与身份证人物面比对失败，请重新上传！',
                                offset: 100,
                                type: 'warning',
                                duration: 1500
                            });
                        }


                    } else {
                        this.$message({
                            message: '修改失败',
                            offset: 250,
                            type: 'warning',
                            duration: 1500
                        });
                    }
                }).catch(err => {
                    this.$message({
                        message: '服务器繁忙！',
                        type: 'warning'
                    });
                })
            }
        }
    }
</script>

<style scoped>
    div /deep/ .el-upload__input {
        display: none !important;
    }

    div /deep/ .el-upload-dragger {
        background-color: #fff;
        border: 0px dashed #d9d9d9 !important;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: auto !important;
        height: auto !important;
        text-align: inherit !important;
        position: relative;
        overflow: hidden;
    }

    div /deep/ .el-input {
        position: relative;
        font-size: 14px;
        display: inline-block;
        width: 300px;
    }

    .form-btn {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        height: 40px;
    }

    .form-btn-blue {
        color: #fff;
        background-color: #4b95ff;
        border-color: #4b95ff;
    }

    .form-ele-box .form-item {
        margin-bottom: 18px;
    }

    .set-20180409-ccj .item .form-input {
        margin-right: 15px;
    }

    .form-ele-box .form-input {
        display: block;
        height: 40px;
        line-height: 38px;
        background: #fff;
        border: 1px solid #ccc;
        padding: 0 10px;
        outline: none;
        color: #262e39;
        border-radius: 3px;
        width: 100%;
    }

    .form-ele-box .form-label {
        display: inline-block;
        line-height: 1.4;
        margin-bottom: 5px;
        max-width: 100%;
    }

    .form-ele-box.form-inline-box .form-label {
        float: left;
        text-align: right;
        width: 100px;
        margin-right: 15px;
        margin-bottom: 0;
        height: 40px;
        line-height: 38px;
    }

    .form-ele-box .form-item {
        margin-bottom: 18px;
    }

    .form-ele-box {
        font-size: 14px;
    }

    .text-center {
        text-align: center;
    }

    .set-20180409-ccj .user-pic {
        position: absolute;
        top: 28px;
        right: 28px;
    }

    .set-20180409-ccj .item {
        padding: 28px;
    }

    .set-20180409-ccj .set-info {
        position: relative;
    }

    .font-16 {
        font-size: 16px;
    }

    .md-2018040807-xxw .top-titx {
        padding: 0 !important;
    }

    .md-2018040807-xxw .top-titx {
        line-height: 60px;
        padding: 0 28px;
        border-bottom: 1px solid #ddd;
    }

    .bgcolor-f6f5fa {
        background: #fff;
    }

    .md-2018040807-xxw .right-contx {
        width: 940px;
        min-height: 450px;
        padding-bottom: 34px;
        border-radius: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/personalCenter/accountSet.vue